import { render } from "./Companies.vue?vue&type=template&id=232d0c9e&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-232d0c9e"

export default script